<template>
  <div>
    <div v-if="!readOnly" class="op">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form v-if="operationSelected" class="b-layout" @submit.prevent="">
      <b-card>
        <div v-for="(prop, index) in equipments" :key="prop.caption + index">
          <b-form-checkbox
              class="switch-item"
              v-model="prop.value"
              @change="ChangeOnOff($event, prop)"
              switch
              >
              {{ prop.equipName }}
          </b-form-checkbox>
        </div>
      </b-card>
      <div class="ml-3">
        <b-card>
          <div class="inp">
            <label>{{ $t('fracao-massica-de-levedura-no-vinho') }} </label>
            <input
              v-model="Xl.value"
              step="0.01"
              min="0"
              max="100"
              type="number"
            />
          </div>
          <div class="inp">
            <label>{{ $t('fracao-massica-de-levedura-no-creme') }} </label>
            <input
              v-model="Xv.value"
              step="0.01"
              min="0"
              max="100"
              type="number"
            />
          </div>
          <div class="inp">
            <label>{{ $t('rendimento-global-da-fermentacao') }} </label>
            <label>{{ Rendimento.value | ParseNumber }}</label>
          </div>
          <div class="inp">
            <label>{{ $t('capacidade-instalada-ton-h') }} </label>
            <label>{{ Capacidade.value | ParseNumber }}</label>
          </div>
          <div class="inp">
            <label>{{ $t('ocupacao-0') }} </label>
            <label>{{ Ocupacao.value | ParseNumber }}</label>
          </div>
        </b-card>
      </div>
    </b-form>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { FiltersMixin } from "../../../mixins/filtersMixin";
import { SingletonInter } from '../_service/singletonInter';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [FiltersMixin],

  data() {
    return {
      attrList: ["Xl", "Xv", "Rendimento", "Ocupacao", "Capacidade"],
      Xl: {},
      Xv: {},
      Rendimento: null,
      Capacidade: {},
      Ocupacao: null,
      operationSelected: null,
      operations: [{ value: null, text:SingletonInter.$t('selecione-uma-operacao') }],
      operationAttributeList: [],
      firstLoad: false,
      equipments: [],
      equipCap: [],
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
      this.updateNode();
    },

    "Capacidade.value"(){
      this.updateNode();
    },

    "Xl.value"() {
      this.updateNode();
    },

    "Xv.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;
        this.loadNotInput();
      }
      this.equipments = new Array();
      
      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }
        
        if (p.equipName) {
          let result = ParseToNumber(p.value) ? true : false;
          p.value = result;
          this.equipments.push(p);
        }
      });
      this.loadEquipments();
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Quantidade") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            this.equipCap.push(props[p]);
          }
        });
      });
      this.equipments = auxEquipment;
      this.ChangeCapacidade();
    },

    updateNode() {
      let attrs = [this.Xl.clone(), this.Xv.clone()];
      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? "1,00" : "0,00";
        attrs.push(prop);
      });
      this.node.attrs = attrs;
    },

    ChangeCapacidade() {
      if (this.Capacidade) {
        this.Capacidade.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          let isTrue = JSON.parse(e.value);
          if (isTrue && cap) {
            this.Capacidade.value += parseFloat(
              String(cap.value).replace(",", ".")
            );
          }
        });
      }
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/\bCF/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacidade();
      this.updateNode();
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacidade();
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.op {
  margin: 2%;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>